import useAppStore from "@/context/store";
import { Modal, Switch } from "antd";
import { useCallback } from "react";

/**
 * 设置私有与公开
 */
export default function PrivateRadio({
  isPro,
  disabled,
  checked,
  onChange,
  ...props
}) {
  const config = useAppStore(({ config }) => config);
  const onChangeValue = useCallback(
    (value) => {
      if (!isPro && !value) {
        Modal.confirm({
          title: "确定公开",
          width: 450,
          content: (
            <>
              <div>确定公开此画板？一旦公开则无法重新设为私有画板。</div>
              <div style={{ color: "rgba(30, 32, 35, 0.65)" }}>
                如需继续正常使用私有画板，您可以去
                <a
                  style={{ textDecoration: "underline" }}
                  href="//pro.huaban.com/?utm_source=huaban&utm_medium=boardModal"
                  target="_blank"
                  rel="noreferrer"
                >
                  续费{config?.gaodingProText}会员
                </a>
              </div>
            </>
          ),
          okText: "确定",
          cancelText: "取消",
          onOk: async () => {
            onChange && onChange(value);
          },
        });
        return;
      }
      onChange && onChange(value);
    },
    [config, isPro, onChange]
  );

  return (
    <div>
      <Switch
        {...props}
        onChange={onChangeValue}
        checked={checked}
        disabled={(!isPro && !checked) || disabled}
        data-gd-click="button_click"
        data-button-name={checked ? "取消私有画板" : "设为私有画板"}
      ></Switch>
      <span className="color-text-2" style={{ paddingLeft: "4px" }}>
        设为私有画板
        {isPro ? (
          ""
        ) : (
          <span>
            (该功能仅对
            <a
              className="color-primary"
              target="_blank"
              href={config?.gaodingProUrl}
              rel="noreferrer"
              data-gd-click="button_click"
              data-button-name="私有_稿定Pro会员"
            >
              {config?.gaodingProText}会员
            </a>
            开放)
          </span>
        )}
      </span>
    </div>
  );
}
